import Cricket from "./Cricket";

export default Cricket;